var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFacebook = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#jottacloud_Facebook.svg__a)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "#fff",
  rx: 8
}), /*#__PURE__*/React.createElement("path", {
  fill: "#316FF6",
  d: "M16 7.412v1.255q-.017.065-.031.133c-.057.36-.086.728-.178 1.08-.753 2.906-2.55 4.85-5.38 5.822-.37.127-.758.198-1.148.297V10.36h.18c.505 0 1.01-.003 1.516.001.11 0 .167-.014.174-.149.013-.225.056-.448.092-.67l.245-1.512H9.253c0-.576-.024-1.137.008-1.693.023-.438.264-.804.727-.975.271-.1.548-.08.825-.082.247-.003.495 0 .739 0V3.302c-.048 0-.085.004-.121 0-.463-.05-.926-.118-1.39-.152a3.9 3.9 0 0 0-1.24.122c-.743.193-1.306.618-1.669 1.302-.288.545-.373 1.137-.38 1.744-.004.518 0 1.035 0 1.554v.175h-2.02v2.325h2.013v5.599c-.034 0-.06.004-.085 0-1.737-.313-3.24-1.086-4.445-2.384C.35 11.577-.335 9.194.15 6.502c.345-1.904 1.3-3.48 2.802-4.694C4.888.243 7.103-.295 9.538.153c1.676.309 3.101 1.115 4.274 2.357a7.9 7.9 0 0 1 2.063 4.086c.048.27.083.544.125.815z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "jottacloud_Facebook.svg__a"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "#fff",
  rx: 8
})))));
export default SvgFacebook;